<template>
<div class="">
    <all-header></all-header>

    <div class="login-bj">
    <div class="login-left"></div>
    <div class="login-fillin">
      <div class="login-logo">
        <img src="../../public/images/logo1.png" />
      </div>
      <div class="login-title">世界至德</div>

      <el-form
        ref="loginForm"
        :model="loginForm"
        class="login-form"
        auto-complete="on"
        label-position="left"
      >
        <div class="login-infi">
          <div class="login-Inp">
            <el-input
              v-model="loginForm.mobile"
              class="logIn"
              placeholder="请输入手机号"
              prefix-icon="el-icon-user"
            >
            </el-input>
          </div>

          <div class="login-Inp">
            <el-input
              v-model="loginForm.password"
              type="password"
              class="logIn"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
            >
            </el-input>
          </div>

          <div class="login-remeforgot">
            <router-link to="/forgotpassword" class="login-forgot"
              >忘记密码？</router-link
            >
          </div>

          <div class="mt20">
            <div class="slider-check-box">
              <div class="slider-check" :class="rangeStatus ? 'success' : ''">
                <i
                  @mousedown="rangeMove"
                  :class="rangeStatus ? successIcon : startIcon"
                ></i>
                {{ rangeStatus ? successText : startText }}
              </div>
            </div>
          </div>

          <div class="login-but" @click="login(loginForm)">登录</div>
        </div>
      </el-form>
    </div>
  </div>
</div>
  
</template>

<script>
import AllHeader from "../components/Header.vue"; //公用头部
export default {
  components: {
    AllHeader,
  },
  props: {
    // 成功之后的函数
    successFun: {
      type: Function,
    },
    //成功图标
    successIcon: {
      type: String,
      default: "el-icon-success",
    },
    //成功文字
    successText: {
      type: String,
      default: "",
    },
    //开始的图标
    startIcon: {
      type: String,
      default: "el-icon-d-arrow-right",
    },
    //开始的文字
    startText: {
      type: String,
      default: "",
    },
    //失败之后的函数
    errorFun: {
      type: Function,
    },
    //或者用值来进行监听
    status: {
      type: String,
    },
  },
  data() {
    return {
      loginForm: {
        mobile: "", //用户名
        password: "", //密码
      },
      logillus: false, //是否同意 说明
      disX: 0, //滑动
      rangeStatus: false, //滑动
      reset: "", //滑动
      ischeck: "",
    };
  },
  mounted() {
    this.$layer.closeAll("loading");
  },
  methods: {
    //滑块移动
    rangeMove(e) {
      let ele = e.target;
      let startX = e.clientX;
      let eleWidth = ele.offsetWidth;
      let parentWidth = ele.parentElement.offsetWidth;
      let MaxX = parentWidth - eleWidth;
      this.reset = e;
      if (this.rangeStatus) {
        //不运行
        return false;
      }
      document.onmousemove = (e) => {
        let endX = e.clientX;
        this.disX = endX - startX;
        if (this.disX <= 0) {
          this.disX = 0;
        }
        if (this.disX >= MaxX - eleWidth) {
          //减去滑块的宽度,体验效果更好
          this.disX = MaxX;
        }
        ele.style.transition = ".1s all";
        ele.style.transform = "translateX(" + this.disX + "px)";
        e.preventDefault();
      };
      document.onmouseup = () => {
        if (this.disX !== MaxX) {
          ele.style.transition = ".5s all";
          ele.style.transform = "translateX(0)";
          this.disX = 0;
          //执行成功的函数
          this.errorFun && this.errorFun();
        } else {
          if (!this.loginForm.mobile) {
            this.$layer.msg("请填写手机号");
            ele.style.transition = ".5s all";
            ele.style.transform = "translateX(0)";
            this.disX = 0;
            document.onmousemove = null;
            document.onmouseup = null;
            return;
          }

          if (!this.loginForm.password) {
            this.$layer.msg("请填写密码");
            ele.style.transition = ".5s all";
            ele.style.transform = "translateX(0)";
            this.disX = 0;
            document.onmousemove = null;
            document.onmouseup = null;
            return;
          }
          this.rangeStatus = true;
          if (this.status) {
            this.$parent[this.status] = true;
          }
          //执行成功的函数
          this.successFun && this.successFun();
        }
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
    login() {
      if (this.disX == 0) {
        this.$layer.msg("请先滑动验证");
      } else {
        this.$layer.loading();
        this.$http
          .post("login", {
            mobile: this.loginForm.mobile,
            password: this.loginForm.password,
          })
          .then((res) => {
            this.$layer.closeAll("loading");
            if (res.data.code == 200) {
              this.$layer.msg(res.data.message);
              localStorage.setItem("pctoken", res.data.data.token);
              localStorage.setItem("user", JSON.stringify(res.data.data));
              this.$router.push("/");
            } else {
              this.$layer.closeAll("loading");
              this.$layer.msg(res.data.message.error);
              this.disX = 0;
              this.rangeStatus = false;
              this.reset.target.style.transition = ".5s all";
              this.reset.target.style.transform = "translateX(0)";
            }
          });
      }
    },
  },
};
</script>

<style scoped>
.login-bj {
  width: 100%;
  height: 79vh;
  position: relative;
  margin-top: 15vh;
}

.login-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 21%; /* 容器宽度占满屏幕*/
  height: 85vh;
  background: url(../../public/images/dlbg.png) no-repeat;
  background-size: 100% 100%;
}

.login-fillin {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  height: 500px;
  background: #ffffff;
  border-radius: 0px 5px 5px 0px;
  transform: translate(-30%, -50%);
}
.login-logo {
  text-align: center;
}
.login-logo img {
  width: 100px;
  height: 110px;
}
.login-title {
  font-weight: bold;
  font-size: 38px;
  color: #333333;
  text-align: center;
  margin-top: 20px;
}
.login-infi {
  padding: 0 56px;
}
.login-Inp {
  border-bottom: 1px solid rgba(216, 216, 216, 1);
  margin-top: 36px;
}
.login-remeforgot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
}

.login-forgot {
  font-weight: 400;
  font-size: 16px;
  color: #a1a1a9;
}
.mt20 {
  margin-top: 20px;
}

.login-but {
  width: 100%;
  height: 48px;
  background: linear-gradient(118deg, #c04549 0%, #9f2227 100%);
  border-radius: 10px;
  text-align: center;
  cursor: pointer;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  line-height: 46px;
  margin-top: 40px;
}
.login-bottom {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  color: #c6c6c7;
  background: #282828;
  position: fixed;
  bottom: 0;
  left: 0;
  text-align: center;
}

.slider-check-box .slider-check {
  position: relative;
  transition: 1s all;
  user-select: none;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  background: #f2f2f2;
  border-radius: 10px;
}
.slider-check-box .slider-check.success {
  background-color: #f2f2f2;
  color: #fff;
}

.slider-check-box .slider-check i {
  position: absolute;
  left: 0;
  width: 50px;
  height: 100%;
  color: #303031;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  font-size: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .slider-check-box .slider-check i {
  width: 42px;
  height: 42px;
  background: linear-gradient(118deg, #c04549 0%, #9f2227 100%), #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.3);
  border-radius: 9px;
}
::v-deep .el-icon-d-arrow-right:before {
  width: 34px;
  height: 28px;
  content: "";
  background: url(../../public/images/jinru.png) no-repeat;
  background-size: 34px 28px;
}

::v-deep .logIn .el-input__inner {
  border: none;
}
</style>
